<template>
  <div class="breadcrumb">
    <div v-for="(item, index) of arr" :key="index" class="breadcrumb-item">
      <a v-if="item.isOut" :href="item.path">{{ item.name }}</a>
      <router-link
        v-else
        :class="[{ 'last-child': index === arr.length - 1 }]"
        tag="a"
        :to="item.path"
      >
        {{ item.name }}
      </router-link>
      <span
        v-if="index !== arr.length - 1"
        class="breadcrumb-right-icon"
      ><i
        class="el-icon-arrow-right"
      /></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BpBreadcrumb',
  data() {
    return {
      arr: []
    }
  },
  mounted() {
    if (this.$route.meta && this.$route.meta.breadcrumb) {
      this.getMenusList(this.$route.meta.breadcrumb)
    }
  },
  methods: {
    getMenusList(json) {
      this.arr.push({
        name: json.name,
        path: json.path,
        isOut: json.isOut
      })
      json.children && this.getMenusList(json.children)
    }
  }
}
</script>

<style lang="scss" scoped>
  .breadcrumb {
    display: flex;
    line-height: 60px;
    .breadcrumb-item {
      a {
        color: #4085f5;
        font-weight: 500;
      }
      .breadcrumb-right-icon {
        color: #c0c4cc;
        margin: 0 6px;
      }
      .last-child {
        color: #606266;
        cursor: text;
      }
    }
  }
</style>
